module.exports = __webpack_public_path__ + "img/ha-stores-map-monochrome.a8a97cad.png";